import { render, staticRenderFns } from "./DiscountCreated.vue?vue&type=template&id=e7555b4c&"
import script from "./DiscountCreated.vue?vue&type=script&lang=js&"
export * from "./DiscountCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports